import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormContextProvider, TabPanelContext, TabPanelContextProvider } from "../../context/ContextIndex";
import { AppFormRootContainer, TabPanel } from "../../components";
import ConsumableProductCreate from "./consumable-product/create/ConsumableProductCreate";
import ConsumableProductList from "./consumable-product/list/ConsumableProductList";
import { getConsumableProductDefaultValue, getConsumableProductSchema } from "./consumable-product/create/schema";
import ReplacementProductView from "./replacement-product/ReplacementProductView";

const ConsumableProductGroupView = ({ displayList }) => {
  return displayList ? (
    <ConsumableProductList />
  ) : (
    <TabPanelContextProvider>
      <AppFormRootContainer>
        <ConsumableProductTabContent />
      </AppFormRootContainer>
    </TabPanelContextProvider>
  );
};

const ConsumableProductTabContent = () => {
  const { t } = useTranslation();
  const consumableProductRef = useRef();
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const consumableProductDefaultValue = getConsumableProductDefaultValue(_tabContext.data?.consumableProduct);

  const [consumableProductFormData, setConsumableProductFormData] = useState({
    consumableProductSchema: getConsumableProductSchema(),
    appformdata: null,
  });

  const handleTabChange = (newTab) => {
    try {
      if (_tabContext.tabIndex === "0") {
        if (consumableProductRef.current) {
          consumableProductRef.current.tabChangeHandler(newTab);
        }
      } else {
        _tabContextObject.setTabFormContext({
          tabIndex: newTab,
        });
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <TabPanel
      tabs={[
        {
          icon: "",
          label: t("consumableProductList.header"),
          children: (
            <FormContextProvider
              schema={consumableProductFormData.consumableProductSchema}
              defaultValues={consumableProductDefaultValue}
              appformdata={consumableProductFormData?.appformdata}
            >
              <ConsumableProductCreate
                ref={consumableProductRef}
                setConsumableProductFormData={setConsumableProductFormData}
                setIsFormValid
              />
            </FormContextProvider>
          ),
        },
        {
          icon: "",
          label: t("navigationMenu.replacement%Product"),
          children: <ReplacementProductView />,
        },
      ]}
      selectedTab={_tabContext.tabIndex}
      onTabChange={handleTabChange}
    />
  );
};

export default ConsumableProductGroupView;
